import { render, staticRenderFns } from "./AvatarLetter.vue?vue&type=template&id=6cf1de36&scoped=true&"
import script from "./AvatarLetter.vue?vue&type=script&lang=js&"
export * from "./AvatarLetter.vue?vue&type=script&lang=js&"
import style0 from "./AvatarLetter.vue?vue&type=style&index=0&id=6cf1de36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf1de36",
  null
  
)

export default component.exports